/**
 * Singleton host/interaction bridge for the floating menu.
 *
 * This mirrors the existing image-edit/font toolbar host pattern in this SPA:
 * there is one EditorView per route, and Fabric canvas event handlers need a
 * module-level way to identify floating-menu interactions outside React.
 */
let host: HTMLElement | null = null;
let isInteracting = false;
let interactionTimeout: ReturnType<typeof setTimeout> | undefined;

export const clearFloatingToolMenuInteraction = (): void => {
  if (interactionTimeout) {
    clearTimeout(interactionTimeout);
    interactionTimeout = undefined;
  }
  isInteracting = false;
};

export const setFloatingToolMenuHost = (element: HTMLElement | null): void => {
  host = element;
  if (!element) {
    clearFloatingToolMenuInteraction();
  }
};

export const setFloatingToolMenuInteracting = (interacting: boolean): void => {
  if (interactionTimeout) {
    clearTimeout(interactionTimeout);
  }

  if (interacting) {
    isInteracting = true;
    interactionTimeout = setTimeout(() => {
      isInteracting = false;
      interactionTimeout = undefined;
    }, 500);
    return;
  }

  // Keep a short grace window after pointer-up because Fabric may emit
  // selection-cleared/mouse-up after the DOM interaction has ended.
  interactionTimeout = setTimeout(() => {
    isInteracting = false;
    interactionTimeout = undefined;
  }, 100);
};

export const isInsideFloatingToolMenu = (target: Element | null): boolean => {
  if (!host || !target) {
    return false;
  }
  return host.contains(target);
};

export const isFloatingToolMenuInteracting = (): boolean => isInteracting;

export const isFloatingToolMenuInteraction = (target: Element | null): boolean =>
  isFloatingToolMenuInteracting() || isInsideFloatingToolMenu(target);
